const HOST = process.env.VUE_APP_BACKEND_HOST
const baseURL = HOST + '/api/'

const endpoints = [
  {
    USER: [
      { GET_ALL: "users" },
      { SHOW: "users/{id}" },
      { INSERT: "users" },
      { UPDATE: "users/{id}" },
      { UPDATE_PASSWORD: "users/{id}/password" },
      { DELETE: "users/{id}" },
    ],
  },
  {
    ROLE: [{ GET_ALL: "roles" }],
  },
  {
    CATEGORY: [{ GET_ALL: "categories" }, { LIST: "categories/list" }],
  },
  {
    PRODUCT: [
      { POOL: "firms/{firm_id}/products/pool" },
      {
        COPY_TO_RESTAURANT: "firms/{firm_id}/products/pool/copy-to-restaurant",
      },
      { COPY_TO_SUPPLIER: "firms/{firm_id}/products/pool/copy-to-supplier" },
      { GET_ALL: "firms/{id}/products/{related_firm_id}" },
      { SHOW: "products/{id}" },
      { VIEW: "products/{id}/view" },
      { GET_PARENTS: "products/{id}/parents" },
      { GET_CHILDS: "products/{id}/childs" },
      { GET_PRODUCT_SUPPLIERS: "firms/{firm_id}/products/{id}/suppliers" },
      { EQUIVALENTS: "firms/{firm_id}/products/{id}/equivalents" },
      { SET_SUPPLIED_PRODUCT: "firms/{firm_id}/products/{id}/supplied" },
      { UPDATE_DEFAULT_STOCK_WAREHOUSE: "firms/{firm_id}/products/{product_id}/default-stock-warehouse" },
      { UPDATE_DEFAULT_STOCK_TARGET: "firms/{firm_id}/products/{product_id}/default-stock-target" },
      { ASSIGN_SUPPLIER: "firms/{firm_id}/products/{id}/assign-supplier" },
      { INSERT: "products" },
      { UPDATE: "products/{id}" },
      { DELETE: "products/{id}" },
      { FORCE_DELETE: "products/{id}/force-delete" },
      { UPLOAD_IMAGE: "products/images/upload" },
      { UPDATE_ACTIVE: "products/{id}/update-active" },
      { UPDATE_COOK_STATION: "products/{id}/update-cook-station" },
      { UPDATE_DEPARTMENT: "products/{id}/update-department" },
      { QUICK_EDIT: "products/{id}/quick-edit" },
      { QUICK_UPDATE: "products/{id}/quick-update" },

      { IMPORT_XML: "import/xml/metro" },
      { IMPORT_EXCEL_RESTAURANT: "restaurant/{firm_id}/products/import/excel" },
      {
        STORE_NEW_POSITION: "restaurant/{firm_id}/products/store-new-position",
      },
      { RE_POSITION: "restaurant/{firm_id}/products/re-position" },
      { PRINTABLE_LIST: "restaurant/{firm_id}/products/list" },
      {
        USED_AS_INGREDIENTS:
          "restaurant/{firm_id}/products/used-as-ingredients",
      },
    ],
  },
  {
    FIRM: [
      { LIST: "firms/list" }, // global'e taşındı
      { LIST_PRODUCT_POOL: "firms/{firm_id}/list-product-pool" }, // global'e taşındı
      { FEATURE_LIST: "firm-feature/{country_id}/list" }, // global'e taşındı
      { USER: "firms/users/{firm_id}" }, // global'e taşındı
      { PRODUCT_LIST: "firms/{id}/product-list/{related_firm_id}" }, // related_firm_id zorunlu değil // global'e taşındı
      { RELATED_FIRMS: "firms/{firm_id}/related-firms" }, // global'e taşındı

      { SHOW: "firms/{id}" }, // global'e taşındı
      { SHOW_BY_HAPPYGAST_ID: "firms/show/{id}" }, // global'e taşındı
      { UPDATE: "firms/{id}" }, // global'e taşındı
      { UPLOAD_LOGO: "firms/images/upload" }, // global'e taşındı
    ],
  },
  {
    SUPPLIER: [
      { SHOW: "suppliers/{id}" }, // supplier'a taşındı
      { GET_BUYER_FIRMS: "suppliers/{supplier_id}/buyer-firms" }, // supplier'a taşındı
      { SET_BUYER_FIRMS: "suppliers/{supplier_id}/buyer-firms" }, // supplier'a taşındı
      {
        SEND_BUYER_FIRM_REQUEST: "suppliers/{supplier_id}/buyer-firms/request",
      }, // supplier'a taşındı
      {
        ACCEPT_BUYER_FIRM_REQUEST: "suppliers/{supplier_id}/buyer-firms/accept",
      }, // supplier'a taşındı
      { GET_ALL_PRODUCTS: "suppliers/{supplier_id}/products" }, // supplier'a taşındı
      { SHOW_PRODUCT: "suppliers/{supplier_id}/products/{id}" }, // supplier'a taşındı
      { STORE_OWN_PRODUCT: "suppliers/{supplier_id}/products" }, // supplier'a taşındı
      { UPDATE_OWN_PRODUCT: "suppliers/{supplier_id}/products/{id}" }, // supplier'a taşındı
      { DELETE_OWN_PRODUCT: "suppliers/{supplier_id}/products/{id}" }, // supplier'a taşındı
      {
        FORCE_DELETE_OWN_PRODUCT:
          "suppliers/{supplier_id}/products/{id}/force-delete",
      }, // supplier'a taşındı
      { UPDATE_PRODUCT_PRICES: "suppliers/{supplier_id}/products/{id}/prices" }, // supplier'a taşındı

      {
        PRODUCT_LIST: "suppliers/{supplier_id}/product-list/{related_firm_id}",
      }, // supplier'a taşındı
    ],
  },
  {
    WAREHOUSE: [
      { GET_ALL: "firm/warehouses/{firm_id}" },
      { LIST: "firms/{firm_id}/warehouses/list" },
      { INSERT: "firm/warehouses/{firm_id}" },
      { UPDATE_PRIORITIES: "firms/{firm_id}/warehouses/consumption-priorities" },
      { UPDATE_CENTRAL: "firms/{firm_id}/warehouses/central-warehouse" },
      { SHOW: "warehouses/{id}" },
      { UPDATE: "warehouses/{id}" },
      { DELETE: "warehouses/{id}" },
    ],
  },
  {
    WAREHOUSE_PRODUCT: [
      { WAREHOUSE_PRODUCTS: "warehouse/{id}/products" },
      { ANALYSIS: "firms/{firm_id}/warehouse-products/analysis" },
      { ANALYSIS_CART_PREVIEW: "firms/{firm_id}/warehouse-products/analysis/cart-preview" },
      { SORT_ORDER: "warehouse/{id}/products/sort-order" },
      { UPDATE_SORT_ORDER: "warehouse/{id}/products/sort-order" },
      { SHOW: "warehouse/{id}/products/{product_id}" },
      { UPDATE: "warehouse/{id}/products/{product_id}" },
      { UPDATE_QUANTITY: "warehouse/{id}/products/{product_id}/quantity" },
      {
        UPDATE_ORDER_DEPARTMENT:
          "warehouse/{id}/products/{product_id}/update-order-department",
      },
      { WAREHOUSE_SUPPLIERS: "warehouse/{id}/suppliers" },

      { COPY_TO_WAREHOUSE: "products/copy-to-warehouse" },
      { REMOVE_FROM_WAREHOUSE: "products/{id}/remove-from-warehouse" },
      { STOCK_TRANSFER: "products/{id}/stock-transfer" },
    ],
  },
  {
    SHIPPING_AREAS: [
      { GET_ALL: "warehouse/{id}/shipping_areas" },
      { LIST: "warehouse/{id}/shipping_areas/list" },
      { INSERT: "warehouse/{id}/shipping_areas" },
      { UPDATE_STATUS: "warehouse/{id}/shipping_areas/{shipping_area_id}" },
      { DELETE: "warehouse/{id}/shipping_areas/{shipping_area_id}" },
    ],
  },
  {
    ADDRESS: [
      { COUNTRY_LIST: "country/list" },
      { PROVINCE_LIST: "country/{country_id}/province/list" },
      { CITY_LIST: "province/{province_id}/city/list" },
    ],
  },
  {
    PRODUCT_GROUP: [
      { GET_ALL: "firms/pgroups/{firm_id}" },
      { LIST: "firms/{firm_id}/pgroups/list" },
      { INSERT: "firms/{firm_id}/pgroups" },
      { SHOW: "firms/{firm_id}/pgroups/{id}" },
      { UPDATE: "firms/{firm_id}/pgroups/{id}" },
      { DELETE: "firms/{firm_id}/pgroups/{id}" },

      { STORE_NEW_POSITION: "firms/{firm_id}/pgroups/store-new-position" },
      { RE_POSITION: "firms/{firm_id}/pgroups/reposition" },
      { UPLOAD_IMAGE: "firms/{firm_id}/pgroups/images/upload" },
    ],
  },

  {
    ATRIFY: [
      { GET_ALL: "atrify/items" },
      { GET_ITEMS: "atrify/items/get" },
      { FETCH_ITEMS: "atrify/items/fetch" },
    ],
  },
  
  {
    CASHPAD: [
      { SHOW: "firms/{firm_id}/cashpad" },
      { UPDATE: "firms/{firm_id}/cashpad" },
      { IMPORT_DIGITAL_MENU: "firms/{firm_id}/cashpad/import/digital-menu" },
      { GET_PRODUCTS: "firms/{firm_id}/cashpad/products" },
      { GET_OPTIONS: "firms/{firm_id}/cashpad/options" },
      { PAIR_PRODUCTS: "firms/{firm_id}/cashpad/pair/products" },
      { PAIR_EXTRAS: "firms/{firm_id}/cashpad/pair/extras" },
      { PAIR_INGREDIENTS: "firms/{firm_id}/cashpad/pair/ingredients" },
    ],
  },

  {
    STOCK: [{ MOVEMENT: "firms/{firm_id}/stock/stock-movement" }],
  },

  {
    HAPPYGAST: [{ GET_NEW_RESTAURANTS: "happy-gast/get-new-restaurants" }],
  },
];

function get(p, c, id) {
  const parentValues = Object.values(endpoints.find(item => item[p]))[0],
    childValues = Object.values(parentValues.find(item => item[c]))[0];
  return baseURL + (
    id ?
    childValues.replace("{id}", id) :
    childValues.replace("{id}", ''));
}

export default {
  HOST,
  baseURL,
  get
}
